import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Compass } from "lucide-react";
import { colors, type, spacing, radius } from "@/theme";
import { api } from "@/lib/api";
import { useCustomer } from "@/context/CustomerContext";

// QR landing: /m/:slug. Decides where to send the customer.
export default function QrLanding() {
  const navigate = useNavigate();
  const { slug } = useParams();
  const { setSlug, session, slug: ctxSlug, ready, leaveSession } = useCustomer();
  const [errMsg, setErrMsg] = useState(null);

  useEffect(() => {
    if (!ready || !slug) return;
    (async () => {
      let t;
      try { t = await api.getTenant(slug); } catch (e) { setErrMsg(e.message || "not-found"); return; }
      if (t?.is_demo) {
        await leaveSession();
        setSlug(slug);
        navigate(`/m/${slug}/tavolo`, { replace: true });
        return;
      }
      setSlug(slug);
      if (t?.ordinazione_abilitata === false) { navigate(`/m/${slug}/menu`, { replace: true }); return; }
      const same = session && session.session_id && ctxSlug === slug;
      navigate(same ? `/m/${slug}/menu` : `/m/${slug}/tavolo`, { replace: true });
    })();
    // eslint-disable-next-line
  }, [ready, slug]);

  if (errMsg) {
    const blocked = /disponibile|bloc|sospes/i.test(errMsg);
    return (
      <div data-testid="menu-not-available" style={{ minHeight: "100vh", background: colors.bg, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: spacing.xl, gap: spacing.md, textAlign: "center" }}>
        <div style={{ width: 80, height: 80, borderRadius: 40, background: colors.accentSoft, display: "flex", alignItems: "center", justifyContent: "center" }}><Compass size={38} color={colors.accent} /></div>
        <div style={{ ...type.serif, fontSize: 26, color: colors.ink }}>{blocked ? "Menu non disponibile" : "Menu non trovato"}</div>
        <div style={{ ...type.sans, fontSize: 15, color: colors.inkSoft, lineHeight: "22px", maxWidth: 360 }}>
          {blocked
            ? "Questo menu non è al momento disponibile. Chiedi al personale del locale."
            : "Il menu che cerchi non esiste o è stato rimosso. Controlla di aver inquadrato il QR giusto."}
        </div>
        <a data-testid="not-available-site" href="https://tavoline.it" style={{ background: colors.accent, minHeight: 50, display: "inline-flex", alignItems: "center", justifyContent: "center", borderRadius: radius.md, color: colors.onAccent, ...type.sansSemi, fontSize: 16, padding: `0 ${spacing.xl}px`, textDecoration: "none", marginTop: spacing.sm }}>Scopri Tavoline</a>
      </div>
    );
  }
  return <div style={{ minHeight: "100vh", background: colors.bg, display: "flex", alignItems: "center", justifyContent: "center" }}><div style={{ ...type.sans, color: colors.accent }}>Caricamento…</div></div>;
}
